import React from 'react';
import { Navigate, Outlet } from "react-router-dom";
import { useAuthorisation } from "./AuthorisationProvider";

const PrivateRoute = () => {
    const token = useAuthorisation().token;
    if (!token || new Date(token.expiresOn) < Date.now())
        return <Navigate to="/login" />

    return <Outlet/>
}

export default PrivateRoute;